import cx from 'classnames';
import type { FunctionComponent } from 'react';

import { useBoardSwitcherMode } from '@trello/board-switcher';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useSplitScreenSharedState } from '@trello/split-screen';

import { SearchField } from './SearchField';
import { ToggleLayoutButton } from './ToggleLayoutButton';
import { TogglePanelButton } from './TogglePanelButton';

import * as styles from './BoardSwitcherHeader.module.less';

interface BoardSwitcherHeaderProps {
  isPanel?: boolean;
}

export const BoardSwitcherHeader: FunctionComponent<
  BoardSwitcherHeaderProps
> = ({ isPanel }) => {
  const { value: isBoardSwitcherPanelEnabled } = useFeatureGate(
    'billplat_board_switcher_panel',
  );

  const mode = useBoardSwitcherMode();

  const { configuration: splitScreenConfiguration } =
    useSplitScreenSharedState();

  const shouldShowToggleLayoutButton =
    mode !== 'panel' && splitScreenConfiguration !== 'tabs';

  return (
    <div
      className={cx(styles.container, {
        [styles.panel]: isPanel,
      })}
    >
      <SearchField />
      {shouldShowToggleLayoutButton && <ToggleLayoutButton />}
      {isBoardSwitcherPanelEnabled && <TogglePanelButton />}
    </div>
  );
};
